export default "__VITE_ASSET__b31e5233__$_?component__"